function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "icon_contact_phone");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u5173\\u4E8E\\u6211\\u4EEC",
  transform: "translate(-530.000000, -4685.000000)"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u6211\\u4EEC",
  transform: "translate(-2.000000, 4403.000000)"
}, React.createElement("g", {
  id: "Repeat-Group",
  transform: "translate(377.000000, 242.000000)"
}, React.createElement("g", {
  id: "template/card/contact"
}, React.createElement("g", {
  id: "Group-2"
}, React.createElement("g", {
  transform: "translate(127.000000, 40.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(28.500000, 0.000000)"
}, React.createElement("g", {
  id: "icon/contact/phone"
}, React.createElement("g", null, React.createElement("path", {
  d: "M22.3301782,10.429913 C22.9990482,10.1321592 23.844117,9.98907156 24.8653846,10.0006501 C25.8680456,10.0120177 26.8703367,10.1724586 27.8722578,10.4819729 C28.542735,10.6891026 29,11.3089481 29,12.0106905 L29,15.1356993 C29,16.007663 28.3018057,16.7190714 27.4299953,16.7354181 L24.6069472,16.7883512 C24.2457852,16.7951659 23.9339697,17.043136 23.8460461,17.3934985 C23.1794513,20.049779 22.8461538,22.5706549 22.8461538,24.9561264 C22.8461538,27.2293319 23.1806563,29.7743255 23.8496613,32.5911071 C23.9352776,32.9517108 24.2573813,33.2062729 24.6280094,33.2062729 L27.4,33.2062729 C28.2836556,33.2062729 29,33.9226173 29,34.8062729 L29,38.0601676 C29.0000093,38.7776055 28.5224463,39.4073354 27.8316037,39.6008648 C26.8432676,39.8777327 25.8545279,40.0105595 24.8653846,39.9993452 C23.819636,39.9874891 22.9586608,39.8146444 22.2824591,39.4808112 L22.2824552,39.4808192 C21.9233853,39.3035504 21.6438403,38.9980818 21.4990267,38.6247396 C19.8330089,34.3295989 19,29.7733945 19,24.9561264 C19,20.1488207 19.8295671,15.6015 21.4887012,11.3141643 L21.4887152,11.3141697 C21.6413297,10.9198015 21.943859,10.6018867 22.3301782,10.429913 Z",
  id: "Rectangle",
  stroke: "currentColor",
  strokeWidth: 1.6,
  transform: "translate(24.000000, 25.000000) rotate(-45.000000) translate(-24.000000, -25.000000) "
}), React.createElement("path", {
  d: "M27.6,15 C27.6,18.5346224 30.4653776,21.4 34,21.4 L34,23 L34,23 C29.581722,23 26,19.418278 26,15 L27.6,15 L27.6,15 Z M30,15 C30,17.209139 31.790861,19 34,19 L34,20.6 L34,20.6 C30.9072054,20.6 28.4,18.0927946 28.4,15 L30,15 L30,15 Z",
  id: "Combined-Shape",
  fill: "currentColor",
  fillRule: "nonzero",
  transform: "translate(30.000000, 19.000000) rotate(-180.000000) translate(-30.000000, -19.000000) "
}), React.createElement("g", {
  id: "empty"
}, React.createElement("rect", {
  x: 0,
  y: 0,
  width: 48,
  height: 48
}))))))))))));

var SvgContactIconPhone = function SvgContactIconPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "49px",
    height: "48px",
    viewBox: "0 0 49 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContactIconPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact_icon_phone.089b727f.svg";
export { ForwardRef as ReactComponent };